const domify = require('../modules/module-domify')

var ContentLoader = function (options) {
  this.options = options || {}
  this.request
}

ContentLoader.prototype.load = function (url, callback) {
  var self = this
  this.request = new XMLHttpRequest()
  this.request.open('GET', url, true)

  this.request.onload = function () {
    if (self.request.status >= 200 && self.request.status < 400) {
      callback(null, self.request.responseText)
    } else {
      // We reached our target server, but it returned an error
      callback(self.request.responseText)
    }
  }

  this.request.onerror = function (err) {
    callback(err)

    // There was a connection error of some sort
  }

  this.request.send()
}

ContentLoader.prototype.loadElement = function (options, callback) {
  if (!options.element) return new Error('Need an src element')
  if (!options.url) return new Error('Need an url')

  // load the data
  this.load(options.url, function (err, result) {
    if (err) return callback(err)

    var fullContent = domify(result)
    var elementContent = fullContent.querySelector(options.element)
    return callback(null, elementContent)
  })
}

ContentLoader.prototype.cancel = function () {
  if (!this.request) return false
  this.request.abort()
}

module.exports = ContentLoader



// WEBPACK FOOTER //
// ./assets/js/modules/module-content-loader.js